<template>
  <div class="d-flex">
    <MainBarMenuV2 />
    <div class="layout-content container-fluid">
      <HeadingUser />
      <div class="col-12 my-5">
        <Breadcrumb :items="breadcrumb" />
        <div class="d-flex justify-content-between align-items-center">
          <Typography
            text="Repositorio de documentación"
            variant="h1"
            class="m-0"
          />
        </div>
        <Typography
          text="Carga, organiza y gestiona tus documentos de cada litigio con facilidad."
          variant="body"
          class="m-0 pt-2 mt-2"
        />
        <div class="my-4">
          <CardProcess :loading="loading" :record="record" />
        </div>
        <div class="my-4">
          <b-overlay :show="isLoadingTypeDocument" rounded="sm">
            <template #overlay>
              <OverlayButton clase="overlay-md"> </OverlayButton>
            </template>
            <ListTypeDocument
              :typeDocuments="typeDocuments"
              :processId="processId"
            />
          </b-overlay>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import processSevices from "@/services/legal/service.js";
//Components
import MainBarMenuV2 from "@/components/layouts/MainBarMenuV2.vue";
import HeadingUser from "@/components/user/HeadingUser.vue";
import Typography from "@/components/general/Typography";
import Breadcrumb from "@/components/general/Breadcrumb";
import OverlayButton from "@/components/core/overlay/overlay-button.vue";
import CardProcess from "./components/CardProcess.vue";
import ListTypeDocument from "./components/ListTypeDocument.vue";
export default {
  components: {
    MainBarMenuV2,
    HeadingUser,
    Typography,
    Breadcrumb,
    OverlayButton,
    CardProcess,
    ListTypeDocument,
  },
  data() {
    return {
      breadcrumb: [
        { name: "Procesos", active: false, link: "/legal/process" },
        { name: "Repositorio de documentación", active: true, link: "" },
      ],
      typeDocuments: [],
      isLoadingTypeDocument: true,
      loading: true,
      record: null,
    };
  },
  computed: {
    processId() {
      return parseInt(this.$route.params.id || "0");
    },
  },
  methods: {
    async listTypeDocuments() {
      const me = this;
      me.isLoadingTypeDocument = true;
      try {
        const { data } = await processSevices.getListTypeFiles(me.processId);
        me.typeDocuments = data;
      } catch (error) {
        console.log(error);
      } finally {
        me.isLoadingTypeDocument = false;
      }
    },
    async loadProcess() {
      const me = this;
      me.loading = true;
      try {
        const { data } = await processSevices.getProcess(me.processId);
        console.log(data)
        me.record = data;
      } catch (error) {
        console.log(error);
      } finally {
        me.loading = false;
      }
    },
  },
  mounted() {
    const me = this;
    me.loadProcess();
    me.listTypeDocuments();
  },
};
</script>
